import { useCallback } from 'react';
import type { OnChangeValue } from 'react-select';

import { Box } from 'components/Box/Box';
import { Select } from 'components/Select/Select';
import type { OptionType } from 'components/Select/Select.types';
import { SearchFilterSection } from 'modules/search/components/FiltersSidebar/SearchFilterSection';
import type {
  SearchFacet,
  SearchFacetId,
} from 'modules/search/types/SearchFacet';
import type { SearchFiltersById } from 'modules/search/types/SearchFiltersById';
import { RECENCY_PERIOD_RADIO_OR_SELECT_OPTIONS } from 'utils/constants/general/recency';

type Props = {
  facet: SearchFacet;
  filtersById: SearchFiltersById;
  setSearchFilter: (facetId: SearchFacetId, value?: string) => void;
  expanded: boolean;
  toggleExpanded: () => void;
};

export function SearchFilterSectionRecencySelect({
  facet,
  filtersById,
  setSearchFilter,
  expanded,
  toggleExpanded,
}: Props) {
  const handleChange = useCallback(
    (newValue: OnChangeValue<OptionType, false>) => {
      setSearchFilter('recencyFacet', newValue?.value || undefined);
    },
    [setSearchFilter],
  );

  return (
    <SearchFilterSection
      title={facet.title}
      expanded={expanded}
      toggleExpanded={toggleExpanded}
      data-qa-id="side-filter-facet-recency"
      data-qa-filter-value={(filtersById[facet.id] as string | undefined) || ''}
      count={filtersById[facet.id] ? 1 : 0}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Box mt="24px" zIndex={2}>
          <Select
            name="recency"
            value={(filtersById[facet.id] as string | undefined) || ''}
            options={RECENCY_PERIOD_RADIO_OR_SELECT_OPTIONS()}
            onChange={handleChange}
            menuPosition="fixed"
            isSearchable={false}
            data-qa-id="search-recency-selector"
          />
        </Box>
      </div>
    </SearchFilterSection>
  );
}
